import { captureAnalyticsEvent } from '@/telemetry/posthog';
import type {
  LoginMethodSwitchOpenedAttrs,
  LoginOtpResendRequestedAttrs,
  LoginOtpSubmittedAttrs,
  LoginPageViewedAttrs,
  LoginUsernameSubmittedErrorAttrs,
} from './telemetry.types';

export function loginPageViewedEvent(attributes: LoginPageViewedAttrs) {
  captureAnalyticsEvent('login_page_viewed', attributes);
}

export function loginUsernameSubmittedEvent() {
  captureAnalyticsEvent('login_username_submitted');
}

export function loginUsernameSubmittedErrorEvent(
  attributes: LoginUsernameSubmittedErrorAttrs
) {
  captureAnalyticsEvent('login_username_submitted_error', attributes);
}

export function loginPasswordSubmittedEvent() {
  captureAnalyticsEvent('login_password_submitted');
}

export function loginOtpSubmittedEvent(attributes: LoginOtpSubmittedAttrs) {
  captureAnalyticsEvent('login_otp_submitted', attributes);
}

export function loginOtpResendRequestedEvent(
  attributes: LoginOtpResendRequestedAttrs
) {
  captureAnalyticsEvent('login_otp_resend_requested', attributes);
}

export function loginPasskeyRetryClickedEvent() {
  captureAnalyticsEvent('login_passkey_retry_clicked');
}

export function loginMethodSwitchOpenedEvent(
  attributes: LoginMethodSwitchOpenedAttrs
) {
  captureAnalyticsEvent('login_method_switch_opened', attributes);
}
